<template>

  <div class="root d-inline-block">
    <!--<div v-for="item in worksDone" class="badge" :class="[{'badge-success': item}, {'badge-warning': !item}]">
      <span v-if="item">تکمیل شده</span>
      <span v-else>درحال انجام</span>
    </div>-->
    <div>
      <div class="badge badge-success"   style="cursor: pointer" v-if="worksDone === true">تکمیل شده</div>
      <div class="badge badge-warning"  style="cursor: pointer" v-else>درحال انجام</div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from "vuex";
  import EventBus from "../bus.js";

  export default {
    name: "work-status",
    components: {},
    data() {
     return {
       worksDone:[]
     }
    },
    mounted() {
     /*this.$on("workCompleted", value ((val) =>{
       console.log(val)
       this.worksDone = val;
     }));*/
     this.arrayToString();
    },
    methods: {
      arrayToString() {
        let arr = JSON.parse(localStorage.getItem('worksCompleted'));
        this.worksDone = arr
        // console.log(arr);
      },
      /*updateMaterialTable(data) {
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          id: Math.random() * 100,
          material: data.material,
          percentage: data.percentage
        });
        // this.voucherModel.voucherProductDto.push({
        //   productId: data.productId,
        //   unitVal: data.number || data.unitVal,
        //   price: data.price,
        //   productName: data.productName
        // });
      },*/
      refreshMaterialTable() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"])
    },
    watch: {
      vsTableFeed(val) {
        //this.refreshMaterialTable();
      },
    }
  };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }
</style>
